import {useSearchParams} from 'react-router-dom';

import {DisabilityEnum, NearNeighborhoodEnum, QueryParamsEnum} from 'presentation/constants';
import {AuthorizationStatusEnum} from '../authorizations/constants';

export function useQueryParams() {
	const [searchParams, setSearchParams] = useSearchParams();

	const SEARCH_PARAMS = {
		query: searchParams.get(QueryParamsEnum.SEARCH_QUERY) || '',
		searchByLetter: searchParams.get(QueryParamsEnum.SEARCH_BY_LETTER) || '',
		cityName: searchParams.get(QueryParamsEnum.CITY_NAME) || '',
		ufCode: searchParams.get(QueryParamsEnum.UF_CODE) || '',
		ufName: searchParams.get(QueryParamsEnum.UF_NAME) || '',
		disability: searchParams.get(QueryParamsEnum.DISABILITY) || DisabilityEnum.ALL,
		includeNeighborhoodDistricts:
			searchParams.get(QueryParamsEnum.INCLUDE_NEIGHBORHOOD) ||
			NearNeighborhoodEnum.NOT_INCLUDE,
		step: searchParams.get(QueryParamsEnum.STEP) || '',
		shift: searchParams.get(QueryParamsEnum.SHIFT) || '',
		specialtyName: searchParams.get(QueryParamsEnum.SPECIALTY_NAME) || '',
		cd_procedimento: searchParams.get(QueryParamsEnum.PROCEDURE) || '',
		bookingType: searchParams.get(QueryParamsEnum.BOOKING_TYPE) || '',
		consultProtocolNumber: searchParams.get(QueryParamsEnum.CONSULT_PROTOCOL_NUMBER) || '',
		consultInitialDate: searchParams.get(QueryParamsEnum.CONSULT_INITIAL_DATE) || '',
		consultEndDate: searchParams.get(QueryParamsEnum.CONSULT_END_DATE) || '',
		authorizationStatus:
			searchParams.get(QueryParamsEnum.AUTHORIZATION_STATUS) || AuthorizationStatusEnum.ALL,
		orderBy: searchParams.get(QueryParamsEnum.ORDER_BY) || '',
		protocolType: searchParams.get(QueryParamsEnum.PROTOCOL_TYPE) || '',
		status: searchParams.get(QueryParamsEnum.STATUS) || '',
		initialDate: searchParams.get(QueryParamsEnum.INITIAL_DATE) || '',
		finalDate: searchParams.get(QueryParamsEnum.FINAL_DATE) || '',
		month: searchParams.get(QueryParamsEnum.MONTH) || '',
		year: searchParams.get(QueryParamsEnum.YEAR) || '',
		category: searchParams.get(QueryParamsEnum.CATEGORY) || '',
		calendarActive: searchParams.get(QueryParamsEnum.CALENDAR_ACTIVE) || '',
		localityDistance: searchParams.get(QueryParamsEnum.LOCALITY_DISTANCE) || '',
		distanceOrigin: searchParams.get(QueryParamsEnum.DISTANCE_ORIGIN) || '',
		autocompleteQuery: searchParams.get(QueryParamsEnum.AUTOCOMPLETE_QUERY) || '',
		typeLocalName: searchParams.get(QueryParamsEnum.TYPE_LOCAL_NAME) || '',
		specialtyCode: searchParams.get(QueryParamsEnum.SPECIALTY_CODE) || '',
		subSpecialtyCode: searchParams.get(QueryParamsEnum.SUB_SPECIALTY_CODE) || '',
		hasSubSpecialty: searchParams.get(QueryParamsEnum.HAS_SUB_SPECIALTY) || '',
		isV2: searchParams.get(QueryParamsEnum.IS_V2) || '',
		requestSchedulePermissionCity:
			searchParams.get(QueryParamsEnum.REQUEST_SCHEDULE_PERMISSION_CITY) || '',
		examType: searchParams.get(QueryParamsEnum.EXAM_TYPE) || '',
		serviceType: searchParams.get(QueryParamsEnum.SERVICE_TYPE) || '',
		networkType: searchParams.get(QueryParamsEnum.NETWORK_TYPE) || '',
		networkCode: searchParams.get(QueryParamsEnum.NETWORK_CODE) || '',
		districtNames: searchParams.get(QueryParamsEnum.DISTRICT_NAMES) || '',
		coordinates: searchParams.get(QueryParamsEnum.COORDINATES) || '',
		refundTherapyMode: searchParams.get(QueryParamsEnum.REFUND_THERAPY_MODE) || '',
		comingFrom: searchParams.get(QueryParamsEnum.COMING_FROM) || '',
		distance: searchParams.get(QueryParamsEnum.DISTANCE) || '25',
		professional_code: searchParams.get(QueryParamsEnum.PROFESSIONAL_CODE) || '',
		professional_name: searchParams.get(QueryParamsEnum.PROFESSIONAL_NAME) || '',
	};

	function clearSearch() {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				prev.delete(QueryParamsEnum.SEARCH_BY_LETTER);
				prev.delete(QueryParamsEnum.SHIFT);
				return prev;
			},
			{replace: true},
		);
	}

	return {
		SEARCH_PARAMS,
		clearSearch,
		setSearchParams,
	};
}
